/***
 *
 *   ACCOUNT
 *   Index page for account functions
 *
 **********/

import {
  Animate,
  AuthContext,
  Icon,
  Link,
  Loader,
  useAPI,
} from "components/lib";
import { useContext } from "react";

const Style = {
  subtitle: "font-bold mt-4",
  link: "text-red-600 font-semibold mt-3 inline-block",
};

export function Account(props) {
  const context = useContext(AuthContext);
  const user = useAPI("/api/user");
  const iconSize = 20;

  if (user.loading) return <Loader />;

  return (
    <Animate>
      <div style={{ display: "flex" }}>
        <div
          style={{
            background: "white",
            padding: 25,
            borderRadius: 5,
            marginRight: 20,
            width: 400,
            height: 180,
          }}
        >
          <Icon image="user" size={iconSize} />
          <h2 className={Style.subtitle}>Profile</h2>
          <div>Update your profile information</div>
          <Link url="/account/profile" className={Style.link}>
            Update
          </Link>
        </div>

        <div
          style={{
            background: "white",
            padding: 25,
            borderRadius: 5,
            marginRight: 20,
            width: 400,
            height: 180,
          }}
        >
          <Icon image="lock" size={iconSize} />
          <h2 className={Style.subtitle}>Password</h2>
          <div>
            {user?.data?.["has_password"]
              ? "Change your password"
              : "Create a password"}
          </div>
          <Link url="/account/password" className={Style.link}>
            {user?.data?.["has_password"] ? "Change" : "Create"}
          </Link>
        </div>
      </div>
    </Animate>
  );
}
